import { CONTOUR, getContour } from '@pp/axios'
import { Auth } from 'Pages/auth'
import { ApiChatType, MessageModel } from 'Pages/chat'
import moment from 'moment'

export const getDate = (currentTime: string) => {
	const date = moment(currentTime)
	const days = moment().diff(date.format('YYYY-MM-DD'), 'days')
	const time = date.format('H:mm')
	const month = Number(date.locale('ru').format('M'))
	const day = date.locale('ru').format('D')
	let res
	switch (days) {
		case 0:
			res = time
			break
		case 1:
			res = `Вчера, ${time}`
			break
		default:
			res = `${day} ${moment.monthsShort()[month - 1]}, ${time}`
			break
	}
	return res
}

export const determineSectionBySlug = (slug: string) => {
	// TODO: Если будут появляться новые разделы, нужно будет расширять.
	//  Костыль, потому что бэк изменил логику отдачи чатов
	const registry = [
		'registration_office_redesign',
		'full_time_identification',
		'busines_registration_availables',
		'registry_business_access_neo',
	]

	let result = ApiChatType.IBRO

	if (registry.includes(slug)) result = ApiChatType.BUSINESS_REGISTRATION

	return result
}

export const userName = (authData: Auth) => {
	let res = ''
	if (authData.first_name) res = authData.first_name
	else if (authData.last_name) res = authData.last_name
	return res
}

export const userRoles = (authData: Auth) => authData.roles.map(({ name }) => name).join(', ')

export const serializeParams = (params) => {
	const result = { ...params }

	// eslint-disable-next-line no-restricted-syntax
	for (const key in result) {
		if (typeof result[key] === 'object') result[key] = JSON.stringify(result[key])
	}

	return JSON.stringify(result)
}

export function findUnreadedMessage(messages: MessageModel[] | null, user_id: number | string) {
	return messages.reduce((acc, current) => {
		if (!current.read_for_users?.neo_users?.includes(user_id)) {
			return [...acc, current.id]
		}
		return acc
	}, [])
}

export const getContourChat = (api: boolean): string => {
	const isProd = getContour() === CONTOUR.PROD
	if (api) {
		return isProd
			? `https://uni-chat.dasreda.ru/api/neo/v1/`
			: `https://uni-chat.dev.dasreda.ru/api/neo/v1/`
	}
	if (!api) {
		return isProd ? `wss://uni-chat.dasreda.ru/cable` : `wss://uni-chat.dev.dasreda.ru/cable`
	}
}

export const pathStarSvg = `M12.7252 1.66606L14.1681 4.54154L17.3947 5.00264C19.8873 5.35886 20.8826
8.37149 19.0789 10.1006L16.7442 12.3389L17.2953 15.4993C17.7211 17.9409 15.1154
19.8028 12.8859 18.65L10 17.1579L7.11407 18.65C4.88459 19.8028 2.27887 17.9409
2.70466 15.4993L3.25582 12.3389L0.921059 10.1006C-0.882634 8.37148 0.112674
5.35886 2.6053 5.00264L5.83187 4.54154L7.27484 1.66606C8.38958 -0.555357 11.6104
-0.555349 12.7252 1.66606ZM9.02673 2.51639C9.42485 1.72303 10.5752 1.72303 10.9733
2.51639L12.6183 5.79446C12.7764 6.1095 13.082 6.32786 13.4355 6.37838L17.1138 6.90404C18.004
7.03127 18.3595 8.1072 17.7153 8.72475L15.0536 11.2764C14.7978 11.5216 14.6811 11.8749
14.7415 12.2212L15.3698 15.8241C15.5219 16.6961 14.5913 17.3611 13.795 16.9494L10.5051 15.2483C10.1889
15.0848 9.81113 15.0848 9.49494 15.2483L6.20497 16.9494C5.40872 17.3611 4.47811 16.6961 4.63018
15.8241L5.25851 12.2212C5.31889 11.8749 5.20217 11.5216 4.94636 11.2764L2.28472 8.72475C1.64054
8.1072 1.99601 7.03127 2.88623 6.90404L6.56454 6.37838C6.91805 6.32786 7.22364 6.1095 7.38174
5.79446L9.02673 2.51639Z`

export const delayChat = (time: number) => new Promise((resolve) => setTimeout(resolve, time))

export const getScrollParamsDirection = (
	isTopDirection: boolean,
	lastMessageId: number,
	lastMessageChatId: number
) =>
	isTopDirection
		? {
				'q[s]': 'created_at DESC',
				'q[id_lt]': lastMessageId,
				'q[id_gt]': null,
				'q[chat_id_eq]': lastMessageChatId,
		  }
		: {
				'q[s]': 'created_at ASC',
				'q[id_gt]': lastMessageId,
				'q[id_lt]': null,
				'q[chat_id_eq]': lastMessageChatId,
		  }

export const getScrollParamsWithLastMessage = (
	isTopDirection: boolean,
	messages: MessageModel[]
) => {
	const lastMessage = isTopDirection ? messages[0] : messages[messages.length - 1]
	if (!lastMessage?.id) return
	return getScrollParamsDirection(isTopDirection, lastMessage?.id, lastMessage?.chat_id)
}

export const findEntryText = (targetText: string, matchText: string) =>
	matchText.split('').reduce((prev) => {
		if (targetText.toLowerCase().includes(prev.toLowerCase())) {
			return prev
		}
		return prev.substr(0, prev.length - 1)
	}, matchText)
